module.exports = __webpack_public_path__ + "static/media/IconTemplates_-76.34c8e17b.svg";